export var BusinessProductUpdateCategory;
(function (BusinessProductUpdateCategory) {
    BusinessProductUpdateCategory["Portal"] = "PORTAL";
    BusinessProductUpdateCategory["Api"] = "API";
    BusinessProductUpdateCategory["General"] = "GENERAL";
})(BusinessProductUpdateCategory || (BusinessProductUpdateCategory = {}));
//# sourceMappingURL=BusinessProductUpdateCategory.js.map